import React from 'react';
import cn from 'classnames';
import { WpIcon } from 'Wpds/components/icon';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  isOpen: boolean;
  onOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function Controls({ onOpen, isOpen }: Props) {
  const { tr } = useTranslation();

  return (
    <div
      className="d-flex justify-content-between border-bottom align-items-end px-4"
      style={{ fontSize: '11px', lineHeight: '147%', height: '42px' }}
    >
      <p className="mt-0 mb-1 text-uppercase">{tr('perform.search.controls.results_title')}</p>
      <div className="d-flex ">
        <button
          type="button"
          className={cn('btn text-primary shadow-none p-0 mb-1', { invisible: isOpen })}
          style={{ fontSize: '16px', lineHeight: '147%' }}
          onClick={onOpen}
        >
          <span className="mx-1">
            <WpIcon name="plus-circle" />
          </span>
          {tr('perform.search.controls.add_filter')}
        </button>
      </div>
    </div>
  );
}
